import { combineEpics } from 'redux-observable'
import { I18n as I } from 'react-redux-i18n'

import Api              from 'lib/Api'
import ReduxHelper      from 'lib/ReduxHelper'
import { GARAGES_ACTION_TYPES as AT }
                        from './Garages.actions'

export default combineEpics (
    ...ReduxHelper.createDefaultEpics(
        [AT.GARAGES_FETCH_DATA, Api.fetchGaragesData],
        [AT.GARAGE_FETCH, Api.fetchGarage],
        [AT.GARAGE_CREATE, Api.createGarage, { successMessage: ()=> I.t('EPICS_GARAGES_GARAGE_CREATED') }], 
        [AT.GARAGE_UPDATE, Api.updateGarage, { successMessage: ()=> I.t('EPICS_GARAGES_GARAGE_UPDATED') }], 
        [AT.GARAGE_DELETE, Api.deleteGarage, { successMessage: ()=> I.t('EPICS_GARAGES_GARAGE_DELETED') }], 
    )
)